import client from "../index.js";
import { GET_ASSET, GET_ASSETS } from "./query.js";
import { CREATE_ASSET, UPDATE_ASSET, DELETE_ASSET, DELETE_ALL_ASSETS } from "./mutation";
import config from "../../config";
import { AUTH_USER_TOKEN_KEY } from "../../utils/constants";

export const apiGetAsset = (id) => {
  return client
    .query({
      query: GET_ASSET,
      variables: {
        id,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res?.data?.mediaAsset;
    });
};

export const apiGetAllAssets = (filter = {}) => {
  return client
    .query({
      query: GET_ASSETS,
      variables: {
        input: filter,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.mediaAssets;
    })
    .catch(async (err) => {
      let detailMessage = null;
      try {
        const token = localStorage.getItem(AUTH_USER_TOKEN_KEY);
        const queryText = GET_ASSETS?.loc?.source?.body;
        if (!queryText) throw new Error("Unable to read GraphQL query text for mediaAssets.");

        const response = await fetch(config.ENV.REACT_APP_BACKEND_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token ? `Bearer ${token}` : "",
          },
          body: JSON.stringify({
            query: queryText,
            variables: {
              input: filter,
            },
          }),
        });

        const rawBody = await response.text();
        detailMessage = `HTTP ${response.status}${response.statusText ? ` ${response.statusText}` : ""}: ${rawBody?.slice(
          0,
          1000
        )}`;
      } catch (fallbackError) {
        detailMessage = fallbackError?.message || detailMessage;
      }
      throw new Error(detailMessage || err?.message || "Failed to load media assets.");
    });
};

export const apiCreateAsset = (data) => {
  return client
    .mutate({
      mutation: CREATE_ASSET,
      variables: {
        input: data,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.createMediaAsset.mediaAsset;
    });
};

export const apiUpdateAsset = (data) => {
  return client
    .mutate({
      mutation: UPDATE_ASSET,
      variables: {
        input: data,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.updateMediaAsset.mediaAsset;
    });
};

export const apiDeleteAsset = (id) => {
  return client
    .mutate({
      mutation: DELETE_ASSET,
      variables: {
        id,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.deleteMediaAsset.id;
    });
};

export const apiDeleteAllAssets = (filter) => {
  return client
    .mutate({
      mutation: DELETE_ALL_ASSETS,
      variables: {
        input: filter,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.deleteAllMediaAssets?.total;
    });
};
